import React from 'react';
import { motion } from 'framer-motion';
export function BookingForm() {
  return <section id="book" className="w-full max-w-[95%] lg:max-w-[85%] mx-auto bg-white text-black my-10 md:my-20" data-id="element-36">
      <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_0.8fr]" data-id="element-37">
        {/* Left: Image Column */}
        <div className="relative aspect-[4/5] lg:aspect-auto" data-id="element-38">
          <img src="https://cdn.magicpatterns.com/uploads/1Vz5tCdw29gKENKFbpT3K5/eed22f9f-5ff7-4c88-b468-c3ca036a69bb.jpg" alt="Sips & Nibbles Event Display" className="absolute inset-0 h-full w-full object-cover" data-id="element-39" />
        </div>

        {/* Right: Form Column */}
        <div className="flex flex-col justify-center px-5 py-4 md:px-10 lg:px-8 xl:px-10 md:py-5 bg-white" data-id="element-40">
          <div className="max-w-lg mx-auto w-full" data-id="element-41">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-6" data-id="element-42">
              <h2 className="text-black font-black uppercase tracking-tighter text-xl sm:text-xl md:text-2xl mb-3 leading-[0.9]" data-id="element-43">
                Book Sips &amp;
                <br data-id="element-44" />
                Nibbles
              </h2>
              <p className="text-black/60 text-sm md:text-base leading-relaxed max-w-sm mx-auto font-medium" data-id="element-45">
                For events, media &amp; press appearances, or partnership
                agreements, please contact:
              </p>
            </motion.div>

            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-46">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-47">
                <div className="space-y-1.5" data-id="element-48">
                  <label htmlFor="name" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-49">
                    Your name
                  </label>
                  <input type="text" id="name" className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors" required data-id="element-50" />
                </div>
                <div className="space-y-1.5" data-id="element-51">
                  <label htmlFor="email" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-52">
                    Your email
                  </label>
                  <input type="email" id="email" className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors" required data-id="element-53" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-54">
                <div className="space-y-1.5" data-id="element-55">
                  <label htmlFor="eventType" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-56">
                    Event Type
                  </label>
                  <select id="eventType" className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors appearance-none" required data-id="element-57">
                    <option value="" data-id="element-58">Select Type...</option>
                    <option value="corporate" data-id="element-59">Corporate Event</option>
                    <option value="private" data-id="element-60">Private Celebration</option>
                    <option value="wedding" data-id="element-61">Wedding</option>
                    <option value="activation" data-id="element-62">Brand Activation</option>
                  </select>
                </div>
                <div className="space-y-1.5" data-id="element-63">
                  <label htmlFor="date" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-64">
                    Event Date
                  </label>
                  <input type="date" id="date" className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors" required data-id="element-65" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-66">
                <div className="space-y-1.5" data-id="element-67">
                  <label htmlFor="guests" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-68">
                    Guest Count
                  </label>
                  <input type="number" id="guests" placeholder="e.g. 150" className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors" required data-id="element-69" />
                </div>
                <div className="space-y-1.5" data-id="element-70">
                  <label htmlFor="location" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-71">
                    Location / Venue
                  </label>
                  <input type="text" id="location" placeholder="City or Venue Name" className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors" required data-id="element-72" />
                </div>
              </div>

              <div className="space-y-1.5" data-id="element-73">
                <label htmlFor="message" className="block text-xs font-black uppercase tracking-[0.2em] text-black" data-id="element-74">
                  Additional Details
                </label>
                <textarea id="message" rows={3} className="w-full bg-[#F8F8F8] border-none px-5 py-3 text-black text-sm md:text-base focus:ring-0 focus:bg-gray-100 outline-none transition-colors resize-none" placeholder="Tell us about your vision..." required data-id="element-75" />
              </div>

              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} type="submit" className="w-full bg-black hover:bg-accent text-white font-black uppercase tracking-[0.3em] text-sm py-4 transition-colors focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-white mt-2" data-id="element-76">
                Submit Inquiry
              </motion.button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}